const keys = {
  auth: {
    loginForm: {
      title: 'Sign in',
      email: 'Email address',
      nextButton: 'Next',
    },
    passcodeForm: {
      title: 'Please check your inbox...',
      desc: 'We just sent your one-time passcode to {{0}}',
      label: 'One-time passcode',
      error: 'This passcode is invalid or expired',
      resendButton: {
        cooldownLabel: 'You can request another code in {{0}} seconds',
        readyLabel: 'Send me a new passcode',
      },
      helpLine1: 'Having trouble to sign in?',
      helpLine2: 'For help, contact us at <email>contact@youset.ca</email>',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
